<img style="display:none" alt="FaviconLoader" [src]="faviconUrl"
(load)="onImageLoaded()" (error)="onImageError()" />
